import React from 'react'

function Spinner() {
    return (
        <div id="spinner" className="d-flex justify-content-center align-items-center my-5">
            <div className="spinner-grow text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default Spinner
